export default {
	home: {
		name: "add goods"
	},
	page_out_trade_no: "Merchant Order Number",
	_start_recording: "Start recording",
	_stop_recording: "Stop recording",
	_switch_obj: "Switch OBJ",
	_switch_gaussian: "Switch Gaussian",
	_switch_glb: "Switch GLB",
	_model_has_no_obj: "This model has no OBJ model",
	_model_has_no_gaussian: "This model has no Gaussian model",
	_model_does_not_exist: "Model does not exist",
	"_no_photos!": "No photos!",
	_image_loading_failed: "Image loading failed",
	_no_gaussian_model_available: "No Gaussian model available",
	_no_normal_map_available: "No model normal map available",
	"_model_loading_failed,_please_try_again_later": "Model loading failed, please try again later",
	"_obj_model_does_not_exist,_automatically_switched_to_gaussian_preview":
		"OBJ model does not exist, automatically switched to Gaussian preview",
	_original_uploaded_photo: "Original uploaded photo",
	_effect_image: "Effect image",
	submit_modeling_model_file_not_ready:
		"The model file is not ready yet. Please try again later or contact support.",
	finance_package_order_reverse: "Package Fixed-Price Reversal",
	finance_shop_red_reversal: "Shop Reversal",
	finance_dealer_red_reversal: "Dealer Reversal"
};
